import { frontendURL } from '../../../../helper/URLHelper';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/labels'),
      component: () => import('../Wrapper.vue'),
      props: {
        headerTitle: 'LABEL_MGMT.HEADER',
        icon: 'tag',
        showNewButton: false,
      },
      children: [
        {
          path: '',
          name: 'labels_wrapper',
          roles: ['administrator'],
          redirect: 'list',
        },
        {
          path: 'list',
          name: 'labels_list',
          roles: ['administrator'],
          component: () => import('./Index.vue'),
          meta: {
            permission: 'show_labels',
          },
        },
      ],
    },
  ],
};
